export const commonAR = {
    first: "الأولى",
    second: "الثانية",
    third: "الثالثة",
    fourth: "الرابعة",
    fifth: "الخامسة",
    sixth: "السادسة",
    seventh: "السابعة",
    eighth: "الثامنة",
    other: "أخرى",
    freeGift: "هدية مجانية",
  "firstName": "الاسم الأول",
  "lastName": "الاسم الأخير",
  "street": "الشارع",
  "streetNumber": "الرقم",
  "city": "المدينة",
  "origin": "المنطقة",
  "postcode": "الرمز البريدي",
  "phone": "رقم الهاتف",
  "apartment": "الشقة",
  "email": "البريد الإلكتروني",
  "emailMessage": "لن نشارك بريدك الإلكتروني مع أي شخص آخر",
  "checkout": "الدفع",
  "streetAndNumber": "الشارع والرقم",
  "privacyStatement": "بيان الخصوصية",
  "termsOfService": "شروط الخدمة",
  "termsOfServiceNoun": "شروط الخدمة",
  "aboutUs": "من نحن",
  "product": "المنتج",
  "products": "المنتجات",
  "subTotal": "المجموع الفرعي",
  "transportation": "تكلفة الشحن",
  "total": "الإجمالي",
  "price": "السعر",
  "quantity": "الكمية",
  "items": "العناصر",
  "firstNameError": "الرجاء إدخال الاسم الأول",
  "lastNameError": "الرجاء إدخال الاسم الأخير",
  "phoneError": "الرجاء إدخال رقم هاتف صالح",
  "emailError": "الرجاء إدخال بريد إلكتروني صالح",
  "save": "حفظ",
  "updateSuccess": "تم التحديث بنجاح",
  "updateError": "حدث خطأ أثناء التحديث",
  "updated": "تم التحديث!",
  "cartUpdated": "لقد قمت بتحديث عربة التسوق الخاصة بك بنجاح!",
  "wishlistUpdated": "لقد قمت بتحديث قائمة الرغبات الخاصة بك بنجاح!",
  "streetError": "الرجاء إدخال اسم الشارع",
  "streetNumberError": "الرجاء إدخال رقم الشارع",
  "cityError": "الرجاء إدخال اسم المدينة",
  "order": "الطلب",
  "logout": "تسجيل الخروج",
  "warning": "تحذير",
  "logoutWarning": "هل أنت متأكد أنك تريد تسجيل الخروج؟",
  "yes": "نعم",
  "no": "لا",
  "loginRegistration": "تسجيل الدخول / التسجيل",
  "login": "تسجيل الدخول",
  "passwordHelperText": "على الأقل 8 أحرف بما في ذلك الأرقام والحروف الكبيرة والصغيرة",
  "forgotPassword": "هل نسيت كلمة المرور؟",
  "or": "أو",
  "facebookLogin": "تسجيل الدخول باستخدام فيسبوك",
  "googleLogin": "تسجيل الدخول باستخدام جوجل",
  "register": "التسجيل",
  "registerButton": "عميل جديد",
  "exit": "خروج",
  "resetPassword": "إعادة تعيين كلمة المرور",
  "resetPasswordInfoA": "الرجاء إدخال عنوان البريد الإلكتروني الخاص بك",
  "resetPasswordInfoB": "وسوف تحصل على كلمة مرور جديدة.",
  "registerA": "تسجيل",
  "registerInfoA": "مع تسجيلي ، أوافق على",
  "registerInfoB": "الشروط العامة للخدمة",
  "registerInfoC": "و",
  "registerInfoD": "بيان الخصوصية",
  "registerInfoE": "و",
  "registerInfoF": "شروط الخدمة للعروض",
  "verificationCode": "تأكيد الرمز",
  "verificationInfo": "الرجاء إدخال الرمز المكون من 4 أرقام الذي تم إرساله إلى:",
  "enterCode": "إدخال الرمز",
  "errorCode": "رمز التحقق غير صحيح، يرجى المحاولة مرة أخرى",
  "codeExpired": "انتهت صلاحية هذا الرمز أو تمت تجربته مرات كثيرة جدًا. اطلب رمزًا جديدًا.",
  "codeTooSoon": "تم إرسال رمز للتو. يرجى الانتظار دقيقة قبل طلب رمز آخر.",
  "codeLocked": "محاولات كثيرة جدًا لهذا البريد الإلكتروني. يرجى المحاولة لاحقًا.",
  "codeEmailTaken": "يوجد حساب بهذا البريد الإلكتروني بالفعل. سجّل الدخول أو أعد تعيين كلمة المرور.",
  "codeAlreadyDone": "حسابك جاهز. يرجى تسجيل الدخول.",
  "codeResent": "تم إرسال رمز جديد إلى بريدك الإلكتروني.",
  "codeSendLimit": "لا يمكن إرسال المزيد من الرموز لهذا التسجيل. أدخل آخر رمز استلمته أو سجّل من جديد.",
  "codeRegisterAgain": "هذا التسجيل لم يعد صالحًا. يرجى التسجيل من جديد.",
  "codeNoAnswer": "لا يوجد رد من المتجر. تحقق من اتصالك وحاول مرة أخرى.",
  "repeat": "إعادة الإرسال",
  "youSee": "أنت ترى",
  "from": "من",
  "stockWarning": "للأسف، المنتج الذي اخترته غير متوفر!",
  "leaveAComment": "اترك تعليقًا...",
  "saveReview": "حفظ التقييم",
  "reviews": "التقييمات",
  "qrCodeBuy": "اشتري بسرعة وسهولة بنقرة واحدة من هاتفك المحمول!",
  "qrCodeScanAndroid": "مسح لتنزيل تطبيقنا لنظام Android",
  "qrCodeDownload": "تحميل تطبيقنا في Android",
  "qrCodeBuyMobile": "لكل من Android و iOS، قم بتنزيل تطبيقنا للمطعم واطلب في أي وقت من هاتفك المحمول!",
  "qrCodeScanIos": "مسح لتنزيل تطبيقنا لنظام IOs",
  "qrCodeForAndroid": "لنظام Android",
  "qrCodeForIos": "لنظام iOS",
  "photoUpload": "تحميل الصورة",
  "edit": "تعديل",
  "delete": "حذف",
  "addCart": "إضافة إلى العربة",
  "noEvaluation": "لا يوجد تقييم بعد.",
  "onlyLoggedInCustomers": "يمكن للعملاء المسجلين فقط الذين قاموا بشراء المنتج كتابة تقييم.",
  "beTheFirstReview": "كن أول من يكتب تقييمًا لهذا المنتج.",
  "seeMoreProducts": "شاهد المزيد من المنتجات",
  "favorite": "المفضلة",
  "favorites": "المفضلة",
  "noFavoritesYet": "ليس لديك منتجات مفضلة بعد",
  "deleteProduct": "هل أنت متأكد أنك تريد إزالة هذا المنتج؟",
  "deleteProduct1": "هل أنت متأكد أنك تريد إزالة هذا المنتج",
  "fromCart": "من العربة؟",
  "deleteAddress": "هل أنت متأكد أنك تريد حذف العنوان؟",
  "danger": "تحذير",
  "connectionIssue": "تنبيه! فشل إرسال الطلب. يرجى التحقق من اتصالك.",
  "sendOrder": "إرسال الطلب",
  "pleaseWait": "الرجاء الانتظار...",
  "noMoreProductsInStock": "لا يمكنك إضافة المزيد من المنتجات إلى عربتك من خلال المخزون",
  "productAddedCart": "تمت إضافة المنتج إلى سلة التسوق الخاصة بك!",
  "home": "الصفحة الرئيسية",
  "myAccount": "حسابي",
  "ckeckout": "الدفع",
  "all": "الكل",
  "signIn": "تسجيل الدخول",
  "search": "البحث",
  "productSKU": "SKU",
  "productSKUFull": "رمز المنتج:",
  "language": "اللغة",
  "size": "الحجم",
  "extra": "إضافي",
  "removeIngredients": "إزالة المكونات",
  "status": "الحالة",
  "searchResults": "نتائج البحث",
  "noResults": "لا توجد نتائج",
  "dailyProducts": "المنتجات اليومية",
  "offersText": "عروض يومية",
  "popularText": "الأكثر شيوعا",
  "productComments": "أدخل تعليقًا أو طلبًا خاصًا (اختياري)",
  "weighted": "منتج مزود بوزن",
  "kgr": "السعر للكيلوغرام الواحد",
  "without": "بدون",
  "noSuchUser": "لا يوجد مستخدم بهذا البريد الإلكتروني!",
  "reset": "إعادة تعيين.",
  "lostPassword": "نسيت كلمة المرور؟",
  "loginOr": "أو تسجيل الدخول باستخدام",
  "here": "هنا",
  "orRegister": "ليس لديك حساب؟ سجل ",
  "stockWarningHeader": "تحذير المخزون",
  "duplicateEmail": "تم استخدام هذا البريد الإلكتروني بواسطة حساب آخر. يرجى محاولة تسجيل الدخول بدلاً من ذلك.",
  "cartUpdatedAlert": "تم تحديث العربة",
  "wishlistUpdatedAlert": "تم تحديث قائمة الرغبات",
  "watchThis": "تحقق من هذه!",
    composition: "التركيب",
  "pickSize": "اختر حجمًا",
  "addExtra": "إضافة مكونات إضافية",
  "logoutAccount": "تسجيل الخروج",
  "deleteAccount": "حذف الحساب",
  "deleteAccountMessage": "هل تريد حقًا حذف حسابك؟",
  "yesSmall": "نعم",
  "noSmall": "لا",
  "show": "عرض العربة",
  "removeItem": "إزالة العنصر",
  "youSure": "هل أنت متأكد؟",
  "cancel": "إلغاء",
  "scannerError": "خطأ أثناء المسح. يرجى المحاولة مرة أخرى.",
  "scannerSuccess": "مرحبًا",
  "scannerMessage": "تابع كضيف في طاولتك",
  "companyOrigin": "المنطقة الرئيسية",
  "addNewAddress": "إضافة عنوان جديد",
  "holidayText": "سوف يظل المكان مغلقًا اليوم",
  "minimumOrderHeader": "الحد الأدنى للطلب",
  "minimumOrder": "الحد الأدنى للطلب هو",
  "appleId": "تم استخدام هذا البريد الإلكتروني لتسجيل الدخول باستخدام Apple",
  "facebookId": "تم استخدام هذا البريد الإلكتروني لتسجيل الدخول بواسطة Facebook",
  "googleId": "تم استخدام هذا البريد الإلكتروني لتسجيل الدخول بواسطة Google",
  "emailPassword": "تم استخدام هذا البريد الإلكتروني لتسجيل الدخول بالبريد الإلكتروني وكلمة المرور",
  "loginError": "خطأ في تسجيل الدخول: ",
  "discount": "الخصم",
  "to": "مفتوح حتى",
  "openingTime": "وقت الفتح",
  "more": "المزيد",
  "lastAddress": "لا يمكن حذف العنوان الأخير",
  "updateFailure": "فشل التحديث",
  "succesDeleteAddress": "تم حذف العنوان بنجاح.",
  "noCategoryItemsYet": "لا توجد منتجات نشطة في هذه الفئة.",
  "reserveTable": "حجز طاولة",
  "reserveTableUC": "حجز طاولة",
  "yourReservation": "حجزك",
  "chooseHour": "اختر الوقت",
  "bookingComment": "إضافة طلب خاص (اختياري)",
  "party": "حفلة",
  "pickDate": "اختر التاريخ",
  "partyOf": "حفلة من",
  date: "تاريخ",
  hour: "وقت",
  customerDiscount: "خصم العملاء",
  couponDiscount: "كوبون الخصم",
  voucherTitle: "لقد ربحت قسيمة ذات قيمة ",
  applyVoucher: "قم بتطبيق هذه القسيمة في سلة التسوق الخاصة بك",
  copy: "ينسخ",
  minimumVoucherOrder: "الحد الأدنى للطلب",
  minimumVoucherCaption: "الحد الأدنى للطلب المطلوب لتطبيق الخصم الخاص بك هو",
  voucherNotApplied: "لم يتم تطبيق القسيمة",
  voucherInvalid: "هذا الرمز غير صالح.",
  voucherExpired: "انتهت صلاحية هذا الرمز.",
  voucherFirstOrderOnly: "صالح لأول طلب لك فقط، بحساب.",
  loyaltyTitle: "مكافآت الولاء",
  loyaltyCaption: "لقد فزت بمكافآت الولاء ذات القيمة الإجمالية",
  loyaltySubCaption: "سيتم خصمها تلقائيًا أثناء الخروج",
  loyaltyMoto:  "استمر في الطلب للفوز بالخصومات",
  endsIn: "ينتهي في",
  days: "أيام",
  table: "طاولة",
  comments: "التعليقات",
  dateCut: "تاريخ",
  newOrder: "طلب جديد",
  num: "الرقم التسلسلي",  
  tableOrder : "طاولة",
  phoneDelivery : "تسليم الهاتف",
  phoneTakeAway : "أخذ الهاتف معك",
  webDelivery : "التسليم عبر الإنترنت",
  webTakeAway : "الويب تيك أواي",
  webTable : "جدول الويب-QR",
  appDelivery : "تسليم التطبيق",
  appTakeAway : "التطبيق جاهز",
  appTable : "جدول APP-QR",
  tip: "نصيحة",
  enterTip: "أدخل النصيحة",
  apply: "تطبيق",
  textTotal: "إجمالي الدفع" ,

    "successfulPayment": "دفع ناجح",
  "unsuccessfulPayment": "دفع غير ناجح",
  "payment": "دفع",
  "confirmation": "تأكيد",
  "tryAgain": "حاول مرة أخرى",
  
    appliedDiscounts: "تم تطبيق الخصومات",
    productName: "اسم المنتج",
    quantity: "كمية",
    totalPrice: "السعر الكلي",
    firstname: "الاسم الأول",
    lastname: "اسم العائلة",
   
    postCode: "شفرة البريد",
    invoiceAddress: "عنوان الفاتورة",
    otherAddress: "عنوان الشحن",
    afm: "الرقم الضريبي",
    doy: "مكتب الضرائب",
    occupation: "إشغال",
    invoiceData: "بيانات الفاتورة",
    yourOrder: "طلبك من",
    withNumber: "مع الرقم",
    dear: "عزيزي السيد / السيدة",
    orderTotalAmount: "مجموع طلبك هو",
    orderDelivery: "سيتم تسليم طلبك قريبا جدا",
    thanks: "شكرا لاختيارك",
    customer: "عميل",
    youReceived: "لقد تلقيت الطلب التالي مع الرقم",
    congrats: "مبروك على النظام",
    newOrderWith: "طلب جديد مع الرقم",

 
    orderingComments: "تعليقات الطلب",
    "selectSmall": "اختيار",    
    delivery: "توصيل",
      course: "دورة",
  view: "عرض",
   "outOfStock": "غير متوفر",
    emailConfirmationCode: "رمز التأكيد",
    emailCodeIs: "رمز التأكيد المكون من 4 أرقام هو",
    emailPasswordReset: "إعادة تعيين كلمة المرور",
    emailNewPassword: "كلمة المرور الجديدة هي",
    emailLoginInfo: "يمكنك تسجيل الدخول باستخدام بريدك الإلكتروني وكلمة المرور الجديدة",
    emailChangePassword: "يمكنك بعد ذلك تغييرها بكلمة مرور خاصة بك",
    partOf: "جزء من",
    errorTitle: "حدث خطأ ما",
    errorMessage: "واجهت هذه الصفحة خطأ غير متوقع. يمكنك المحاولة مرة أخرى، أو العودة إلى الصفحة الرئيسية.",
    goToHome: "الذهاب إلى الصفحة الرئيسية",
    colorThemeLight: "الوضع الفاتح",
    colorThemeDark: "الوضع الداكن",
    colorThemeSystem: "وضع النظام",
    skipToContent: "تخطّي إلى المحتوى",
    mainMenu: "القائمة الرئيسية",
    grams: "g",
    addressTooFar: "يبدو أن هذا العنوان بعيد جدًا عن المتجر، يرجى التحقق منه.",
    addressPickArea: "تم العثور على العنوان، يرجى اختيار منطقتك أدناه.",
    addressLookupFailed: "تعذّرت قراءة هذا العنوان، يرجى كتابته يدويًا.",
    trackOrder: "تتبع الطلب",
    orderStatus: "حالة الطلب",
    trackingUnavailable: "التتبع المباشر غير متاح لهذا الطلب.",
    courierEnRoute: "المندوب في الطريق",
    courierLastSeen: "آخر ظهور للمندوب",
    courierNoPosition: "طلبك مع مندوب التوصيل.",
    orderStatusPending: "قيد الانتظار",
    orderStatusProcessing: "قيد التحضير",
    orderStatusCompleted: "جاهز",
    orderStatusDelivering: "قيد التوصيل",
    orderStatusDelivered: "تم التوصيل",
    adjustPinHint: "اسحب المؤشر إلى مدخلك بالضبط",
    updateAddress: "تحديث العنوان",
    addressPinSaved: "تم تحديث الموقع.",
    paymentUnconfirmedTitle: "لم يتم تأكيد الدفع بعد",
    paymentUnconfirmed: "لم نتمكن بعد من تأكيد دفعتك مع البنك، لذلك لم يتم إرسال طلبك. إعادة المحاولة تتحقق مرة أخرى فقط ولن يتم خصم المبلغ من بطاقتك مرة أخرى.",
    paymentNotVerified: "تعذر التحقق من الدفع بالبطاقة، لذلك لم يتم تقديم الطلب.",
}